import React from 'react';
import { Container, Typography, Box, Paper, Button, Grid, CircularProgress } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { AppointmentType } from '../services/appointmentTypeService';
import { useAuth } from '../contexts/AuthContext';
import { useAppointmentTypes } from '../hooks/useAppointmentTypes';

const AppointmentTypes = () => {
  const { businessId } = useAuth();

  // Use TanStack Query hook
  const {
    data: appointmentTypes = [],
    isLoading: loading
  } = useAppointmentTypes({
    businessId: businessId || undefined,
    enabled: !!businessId
  });

  return (
    <>
      <Helmet>
        <title>Appointment Types | MindShare Calendar</title>
      </Helmet>
      <Container maxWidth="lg">
        <Box sx={{
          p: { xs: 1, sm: 2, md: 3 },
          borderRadius: 1,
        }}>
          <Typography variant="h4" gutterBottom>
            Appointment Types
          </Typography>

          <Button
            variant="contained"
            color="primary"
            sx={{ mb: 3 }}
          >
            Add New Appointment Type
          </Button>

          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Grid container spacing={3}>
                {appointmentTypes.length === 0 ? (
                  <Grid item xs={12}>
                    <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
                      <Typography variant="body1">
                        You don't have any appointment types yet. Click the button above to create your first one.
                      </Typography>
                    </Paper>
                  </Grid>
                ) : (
                  // Map through appointment types
                  appointmentTypes.map((type: AppointmentType) => (
                    <Grid item xs={12} md={6} lg={4} key={type.id}>
                      <Paper elevation={2} sx={{ p: 3 }}>
                        <Typography variant="h6">{type.name}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {type.description}
                        </Typography>
                        <Box mt={2} display="flex" justifyContent="space-between">
                          <Typography variant="body2">
                            Duration: {type.duration} min
                          </Typography>
                        </Box>
                      </Paper>
                    </Grid>
                  ))
                )}
              </Grid>
            </>
          )}
        </Box>
      </Container>
    </>
  );
};

export default AppointmentTypes;
